import type { Locale } from "../types";
import { SUPPORTED } from "../types";

export function resolveLocaleFromQuery(search: string): Locale | null {
  const params = new URLSearchParams(search);

  const lang = params.get("lang")?.toLowerCase();

  if (!lang) return null;
  // ko-KR 같은 값도 들어올 수 있으니 앞부분만
  const normalized = lang.split("-")[0] as Locale;

  return (SUPPORTED as readonly string[]).includes(normalized)
    ? normalized
    : null;
}
